import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'couponsFormSection.title',
    defaultMessage: 'Coupons',
    description: 'Title of the coupons form section',
  },
  button: {
    add: {
      label: {
        id: 'actions.add',
        defaultMessage: 'Add',
        description: 'Label of the add action in the coupons section',
      },
    },
  },
  emptyMessage: {
    id: 'couponsFormSection.emptyMessage',
    defaultMessage: 'No coupons added',
    description: 'Empty message of the coupons form section',
  },
  feedback: {
    couponAdded: {
      id: 'couponsFormSection.feedback.couponAdded',
      defaultMessage: 'Coupon added to order',
      description: 'Success message of the add coupon to order action',
    },
    couponNotAdded: {
      id: 'couponsFormSection.feedback.couponNotAdded',
      defaultMessage: 'Coupon could not be added to order',
      description: 'Error message of the add coupon to order action',
    },
    couponRemoved: {
      id: 'couponsFormSection.feedback.couponRemoved',
      defaultMessage: 'Coupon removed from order',
      description: 'Success message of the remove coupon from order action',
    },
    couponNotRemoved: {
      id: 'couponsFormSection.feedback.couponNotRemoved',
      defaultMessage: 'Coupon could not be removed from order',
      description: 'Error message of the remove coupon from order action',
    },
  },
};

export default defineMessages(translations);
